import { KEY1, KEY2 } from "./Constants";
import { dataDecrypt, dataEncrpt } from "./CryptoUtils";
import { isEmpty } from "./Functions";

export function getUserLoggedLS() {    
  const data = window.localStorage.getItem(KEY1);
  var userLogged = null;
  if (!isEmpty(data)) {
    var decryptedData = dataDecrypt(data);
    userLogged = JSON.parse(decryptedData);
  }
  return userLogged;
}

export function setUserLoggedLS(userLogged) {
  var data = isEmpty(userLogged) ? userLogged : JSON.stringify(userLogged);
  window.localStorage.setItem(KEY1, dataEncrpt(data));
}

export function getCredentialsLS() {
  const data = window.localStorage.getItem(KEY2);
  var credentials = null;
  if (!isEmpty(data)) {
    var decryptedData = dataDecrypt(data);
    credentials = JSON.parse(decryptedData);
  }
  return credentials;
}

export function setCredentialsLS(credentials) {
  var data = JSON.stringify(credentials);
  window.localStorage.setItem(KEY2, dataEncrpt(data));
}
